module.exports = __webpack_public_path__ + "img/reload.fb65ccc3.png";